import { render, staticRenderFns } from "./Clasificatie.vue?vue&type=template&id=346d017a"
import script from "./Clasificatie.vue?vue&type=script&lang=js"
export * from "./Clasificatie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports